import { Component, OnInit, ViewChild, ElementRef, ChangeDetectorRef, Renderer2 } from "@angular/core";
import { Table } from "primeng/table";
import { UserService } from "../../services/user.service";
import { RoleService } from "../../services/role.service";
import { ActivatedRoute, Router } from "@angular/router";
import { ConfirmationService, MessageService } from "primeng/api";
import { TitleCasePipe } from "@angular/common";
import { LazyLoadEvent } from "primeng/api";
import { Dropdown } from "primeng/dropdown";
import { saveAs } from "file-saver/src/FileSaver";
import { maxYearFunction } from "../../_helpers/utility";
import * as moment from "moment";
import { StateService } from "src/app/manage/state/service/state.service";
import { CityService } from "src/app/manage/city/service/city.service";
import { environment } from "src/environments/environment";
import {
  FormBuilder,
  FormGroup,
  FormControl,
  Validators,
  FormsModule,
  FormArray,
} from "@angular/forms";
import { CustomValidators, MaxValidator } from "ng2-validation";
import { AuthService } from "src/app/services/auth.service";
import { TokenStorageService } from "src/app/services/token-storage.service";
import { ScheduleService } from "src/app/services/schedule.service";
import { EventService } from "src/app/demo/service/eventservice";
import { SubscribeService } from "../service/subscribeService.service";
import { BannerService } from "src/app/services/banner.service";
import { WalletpaymentService } from "src/app/services/walletPayments.service";
import { WindowRefService } from "src/app/services/window-ref.service";
import { UserWalletService } from "src/app/services/userWallet.service";
import { Subject, Subscription, timer } from "rxjs";
import { DatePipe } from "@angular/common";
import { ChangeDetectionStrategy } from "@angular/compiler/src/compiler_facade_interface";
import { debounceTime, distinctUntilChanged } from "rxjs/operators";
@Component({
  selector: "app-find-partner",
  templateUrl: "./findpartner.component.html",
  styleUrls: ["./findpartner.component.scss"],
  providers: [MessageService, ConfirmationService, TitleCasePipe, DatePipe],
})
export class FindPartnerComponent implements OnInit {
       position: 'left' | 'right' | 'top' | 'bottom' | 'center' | 'topleft' | 'topright' | 'bottomleft' | 'bottomright' = 'center';
         mobilFilter: boolean = false;
       public downloadModal: boolean = false;
  added_amount: any;
  userName: any;
  charges: any;
  walletBalance: number;
  addCashForm: FormGroup;
  showThankyouModal: boolean = false;
  Walletdialog: boolean = false;
  Addcashmodal: boolean = false;
  displayCashMs: boolean = false;
  showDoublesPartnerSection: boolean = false;
  public comingSoonMsg = environment.comingSoonMsg;
  availableClasses: string[] = ["body-dark", "bg-white", ""];
  currentClassIdx: number = 0;
  bodyClass: string;
  selectedpartner: "";
  partnerform: FormGroup;
  pricerangeform: FormGroup;
  ratingrangeform: FormGroup;
  mobileFilter: boolean;
  isFieldAdded: boolean = false;
  totalCash;
  totalCoins;
  totalleftCash;
  selectedEntryFee: number = 0;
  myForm: FormGroup;
  tournamentId: any;
  tournamentid: any;
  public countDown: Subscription;
  public findPartnerList: any[] = [];
  public filteredList: any[] = [];
  private lazyLoadEvent: LazyLoadEvent;
  public errorMessage;
  public totalRecords;
  public mode;
  item: any = [];
  public userCategories: any[] = [];
  public selectedCategories: any;
  public states: any[] = [];
  public stateListData: any[] = [];
  public selectedStates: any[] = [];
  public selectedCities: any[] = [];
  public cities: any[] = [];
  public citiesListData: any[] = [];
  public roleFilteredArr;
  public loginForm: FormGroup;
  public forgotPassForm: FormGroup;
  public mobileLoginForm: FormGroup;
  public scheduleForm: FormGroup;
  public loginFormSubmitted: boolean = false;
  public otp: string;
  public showForgotPasswordForm: boolean = false;
  public showOtpErrors: boolean = false;
  public showOtpErrorsMsg: boolean = false;
  public showResendButton: boolean = false;
  public showMobileFormErrors: boolean = false;
  public mobileFormsErrors: boolean = false;
  public otpLoginErrors: boolean = false;
  public showOtpLoginErrors: boolean = false;
  public otpErrorMessage;
  public displayTime;
  public genders;
  public message;
  public showMessage: boolean = false;
  public selectedGender: any = null;
  public userType;
  public userData;
  public isLoginFailed: boolean;
  public isLoggedIn: boolean = false;
  public loginRegisterModal: boolean = false;
  public roles;
  public userRoleId;
  public permissions: any = [];
  public roleList: any = [];
  public mobileNumber;
  public submitted = false;
  public showOtpForm: boolean = false;
  public activeIndex: number = 0;
  public successMessage;
  public showMobileLoginOtpForm: boolean = false;
  public loggedInUser: any;
  public userId;
  public showScheduleMatchDialog: boolean = false;
  public selectedCat;
  public options;
  public scheduleId;
  public scheduleDetails;
  public recurringDisabled: boolean = true;
  public ament: any[];
  public amenitiesData: any[];
  public minTime;
  public selectedDate: any;
  public scheduleListArr: any = [];
  public events: any = [];
  public scheduleListArray: any = [];
  public amenitiesArray: any = [];
  public defaultAmenitiesArray = environment.amenitiesArray;
  public scheduleList: any = [];
  public opponentId;
  selectedEntryFees: number[] = [];

  public selectedSchedule: any = [];
  public showScheduleError: boolean = false;
  public pagination = environment.pagination;
  public first = 1;
  rows: Number = 10;
  partid: any;
  objName: any = "";
  result: any;
  nodata: boolean = false;
  @ViewChild("ngOtpInput", { static: false }) ngOtpInput: any;
  totalUserRecords: any;
  totalCityRecords: any;
  downloadFlg: boolean = false;
  sortOrder: number;
  sortField: string;
  selectedFilteredAmenities: any = [];
  selectedRecurring: any = [];
  public recurringArray = environment.recurringArray;
  public selectedFilteredDate: any = [];
  public minvalue: any = null;
  public maxvalue: any = null;
  public minrating: any = null;
  public maxrating: any = null;
  public bannerImage;
  public bannerList: any = [];
  public loading: boolean = false;
  public isLoadingPartners: boolean = true;
  public isLoadingFilters: boolean = true;
  public skeletonCards: number[] = Array(6).fill(0);
  public webBannerImageList: any[] = [];
  public mobileBannerImageList: any[] = [];
  addedAmount: number | null = null;
  thanYoumodal: boolean = false;
  countdownInProgress: boolean = false;
  countdown: number = 11;
  public roleName: string;
  public showCreateSchedule: boolean = false;
  public isAcademy: boolean = false;
  carouselResponsiveOptions: any[] = [
    {
      breakpoint: "1024px",
      numVisible: 12,
      numScroll: 12,
      margin: 20,
    },
    {
      breakpoint: "768px",
      numVisible: 2,
      numScroll: 2,
      margin: 20,
    },
    {
      breakpoint: "560px",
      numVisible: 1,
      numScroll: 1,
    },
  ];
  public slug = "player";
  selectedScheduleData: any = [];
  totalFee: number;
  isRadioButtonClicked: boolean = false;
  showAddMoneyMessage: boolean = false;
  stateCode: any;
  roleId: any;
  rangeDates: Date[];
  public isToday: boolean = false;
  public isTomorrow: boolean = false;
  isplayerVideoApproved: boolean = false;
  selectedVideo: string;
  showVideo: boolean = false;
  isProfileComplete: boolean = false;
  public playervideoClip;
  public userDetails;
  showProfileIncompleteMsg: boolean = false;
  thankYouMsg: boolean = false;
  userAge: any;
  public fapSelectedDate;
  showDescription: boolean;
  showProPlayerRating: boolean;
  showTPLRating: boolean;
  showPlayerCoachRating: boolean;
  termsAndConditionsCheck: boolean = false;
  showTermsAndConditionError: boolean;
  isTAndCSelected: boolean;
  termsAndConditions: boolean = false;
  showMore = false;
  descriptionAvail: any;
  descriptionAvailable: boolean;
  showFindPartnerDescription: boolean = false;
  selectedScheduleId: string | null = null;
  isContestVerified: boolean;
  isAbove18Check: boolean;
  pageNumberFirst: any;
  pageLimitFirst: number;
  isTermsAndConditionsAccepted: boolean = false;
  userRequestsCount: number = 0;
  isRegisterButtonEnabled(): boolean {
    this.showAddMoneyMessage = this.walletBalance < this.totalEntryFee();
    return (
      this.isRadioButtonClicked && this.walletBalance >= this.totalEntryFee()
    );
  }
  allKycList: any;
  kycAdded: boolean = false;
  paymentId: any;
  welcomeLogin: boolean = false;
  selectedState: any = [];
  selectedCity: any = [];
  selectedAmenities: any = [];
  searchedStateName: string = null;
  searchedCityName: string = null;
  searchedAmenityName: string = null;
  private searchSubject = new Subject<string>();
  private academySearchSubscription!: Subscription;
  playerName: string = null;
  selectedStartDate: string;
  selectedEndDate: string;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private userService: UserService,
    private roleService: RoleService,
    private stateService: StateService,
    private winRef: WindowRefService,
    private fb: FormBuilder,
    private cityService: CityService,
    private userWalletService: UserWalletService,
    private formBuilder: FormBuilder,
    private authService: AuthService,
    private tokenStorage: TokenStorageService,
    private elementRef: ElementRef,
    private scheduleService: ScheduleService,
    private eventService: EventService,
    private subscribeService: SubscribeService,
    private messageService: MessageService,
    private bannerService: BannerService,
    private walletpaymentService: WalletpaymentService,
    private datePipe: DatePipe,
    private changeDetectRef: ChangeDetectorRef,
    private renderer: Renderer2,
    private scheduleservice: ScheduleService,
  ) {

  }

  showWalletDialog() {
    this.thankYouMsg = false;
    this.Walletdialog = true;    // this.showScheduleMatchDialog  = false;

    this.totalleftCash = this.walletBalance - this.totalEntryFee();
    this.totalleftCash = this.walletBalance - this.totalEntryFee();
  }

  Addcashdialog() {
    this.resetDialogStates();
    this.Addcashmodal = true;
    this.Walletdialog = true;
    this.addedAmount = null;
  }

  resetDialogStates() {
    this.Addcashmodal = false;
    this.Walletdialog = false;
  }
  Addwalletdialog() {
    this.Walletdialog = true;
  }
  onRadioClick() {
    this.isRadioButtonClicked = true;
    // alert('test')
    this.displayCashMs = true;
    this.totalleftCash = this.walletBalance - this.totalEntryFee();

  }
  getPrevClassIdx(): number {
    return this.currentClassIdx === 0
      ? this.availableClasses.length - 1
      : this.currentClassIdx - 1;
  }

  getNextClassIdx(): number {
    return this.currentClassIdx === this.availableClasses.length - 1
      ? 0
      : this.currentClassIdx + 1;
  }
  ngOnInit(): void {
    this.roleService.setCurrentActiveRoute(this.router.url);
    this.route.queryParams.subscribe((query) => {
      if (query['page']) {
        this.pageNumberFirst = query['page'];
      } else {
        this.pageNumberFirst = 1;
      }
      if (query['limit']) {
        this.pageLimitFirst = +query['limit'];
      } else {
        this.pageLimitFirst = 10;
      }
    })
    setTimeout(() => {
      this.hideDiv();
    }, 20000);
    this.renderer.addClass(document.body, 'find-a-partner-page');
    this.resetCountdown();
    this.getBanner();
    const storedWalletBalance = localStorage.getItem("walletBalance");
    //this.loggedInUser = this.tokenStorage.getUser();
    if (storedWalletBalance) {
      this.walletBalance = storedWalletBalance
        ? parseFloat(storedWalletBalance)
        : 0;
    } else {
      this.walletBalance = 0; // Default value if not found in localStorage
    }
    this.addCashForm = this.formBuilder.group({
      amount: ["", [Validators.required, CustomValidators.number]],
    });
    this.loggedInUser = this.tokenStorage.getUser();
    if (this.loggedInUser.userdata != undefined) {
      this.userId = this.loggedInUser.userdata.id;
      this.isContestVerified = this.loggedInUser.userdata.isContestVerified;
      this.isAbove18Check = this.loggedInUser.userdata.isAbove18;
      //this.isplayerVideoApproved = this.loggedInUser.userdata.isplayerVideoApproved;
      this.getUserDetails(this.userId);
      this.isLoggedIn = true;
      this.roleName = this.loggedInUser.userdata.rolename;      
      // this.descriptionAvail = this.userData.items.description;
      // if (this.descriptionAvail == true) {
      //   this.descriptionAvailable = true;
      // } else {
      //   this.descriptionAvailable = false;
      // }

      //this.roleName = this.loggedInUser.userdata.rolename;
      if (this.roleName == "proplayer" || this.roleName == "coach") {
        this.showDescription = true;
      } else {
        this.showDescription = false;
      }
    }
    this.roleFilteredArr = environment.roleFilteredArray;
    this.scheduleForm = this.formBuilder.group({
      termsAndConditions: [false],
      //schedule: ['', [Validators.required]],
    });
    this.loginForm = this.formBuilder.group({
      email: [
        "",
        [Validators.required, Validators.email, CustomValidators.email],
      ],
      password: ["", [Validators.required, Validators.minLength(6)]],
    });
    this.forgotPassForm = new FormGroup({
      email: new FormControl("", [
        Validators.required,
        Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,3}"),
      ]),
    });
    this.mobileLoginForm = this.formBuilder.group({
      mobileNumber: [
        null,
        [Validators.required, Validators.pattern("[0-9 ]{10}")],
      ],
    });
    this.partnerform = this.formBuilder.group({
      playerValue: [""],
    });
    this.pricerangeform = this.formBuilder.group({
      minvalue: [null, [Validators.min(0)]],
      maxvalue: [null, [Validators.min(0)]],
    });
    this.ratingrangeform = this.formBuilder.group({
      minvalue: [null, [Validators.min(0)]],
      maxvalue: [null, [Validators.min(0)]],
    });
    // this.scheduleForm = this.formBuilder.group({
    //   termsAndConditions: [""],

    // });
    //this.getRoles();
    this.getUserLocations();
    // this.getState();
    this.getplayerid();
    this.fetchSearchResults();
    //this.getCity(this.lazyLoadEvent);
    this.mode = "all";
    // this.getUserList(this.lazyLoadEvent, this.mode);
    let date = new Date();
    this.selectedDate = moment(date).format("YYYY-MM-DD");
    this.getUserBalance();
    this.loadUserKyc();
    this.userRequests();
  }

  getUserLocations() {
    this.isLoadingFilters = true;
    this.userService.getUserLocations().subscribe((data:any) => {
      this.stateListData = JSON.parse(JSON.stringify(data.data.statelist));
      this.states = this.stateListData;
      this.citiesListData = JSON.parse(JSON.stringify(data.data.citylist));
      this.cities = this.citiesListData;
      this.isLoadingFilters = false;
    }, err => {
      this.isLoadingFilters = false;
    })
  }

  onSearchPlayerName(searchTerm: string) {
    this.searchSubject.next(searchTerm.trim());
  }
  
  fetchSearchResults() {
    this.academySearchSubscription = this.searchSubject
      .pipe(
        debounceTime(500),                // Wait 500ms after typing stops
        distinctUntilChanged(),            // Only trigger if query changed
      )
      .subscribe((searchTerm) => {
        if (searchTerm !== '' && searchTerm !== null) {
          this.playerName = searchTerm;
        } else {
          this.playerName = '';
        }
        this.mode = "category";
        this.getUserList(this.lazyLoadEvent,this.mode);
    });
  }

  ngOnDestroy() {
    this.renderer.removeClass(document.body, 'find-a-partner-page');
  }
  async getUserDetails(userId) {
    await this.userService.getUserDetails(userId).subscribe(data => {

      this.userDetails = data;
      //console.log(this.userDetails.status+"   "+this.roleName);
      this.userAge = this.userDetails.age;
      this.isplayerVideoApproved = this.userDetails.isplayerVideoApproved;
      this.isProfileComplete = this.userDetails.isProfileComplete;
      this.playervideoClip = this.userDetails.playervideoClip;
      if (this.isProfileComplete === false || (this.isplayerVideoApproved === false && this.playervideoClip != "")) {
        this.showProfileIncompleteMsg = true;
      } else {
        this.showProfileIncompleteMsg = false;
      }
      //console.log(this.roleName);
      if (this.roleName == "player") {
        this.showCreateSchedule = true;
        this.isAcademy = false;
      } else if (this.roleName == "proplayer" || this.roleName == "coach") {
        if (this.userDetails.status == false) {
          this.showCreateSchedule = false;
        } else {
          this.showCreateSchedule = true;
        }
        this.isAcademy = false;
      } else if (this.roleName == "academy") {
        this.isAcademy = true;
        this.showCreateSchedule = false;
      } else {
        this.showCreateSchedule = false;
        this.isAcademy = false;
      }
      //console.log(this.showCreateSchedule);
    })
  }

  startCountdown(): void {
    this.countdownInProgress = true;
    const interval = setInterval(() => {
      this.countdown--;
      if (this.countdown === 0) {
        clearInterval(interval);
        this.countdownInProgress = false;
      }
    }, 1000);
  }
  convertToClientTimezone(utcDateTime: string): string {
    // Parse UTC date string to a Date object
    const utcDate = new Date(utcDateTime);

    // Use DatePipe to format the date in the client's timezone
    const clientTimezoneDateTime = this.datePipe.transform(utcDate, "medium");

    return clientTimezoneDateTime;
  }
  resetCountdown(): void {
    this.countdown = 10;
    this.countdownInProgress = false;
  }

  get loginf() {
    return this.loginForm.controls;
  }
  get forgotPassValidation() {
    return this.forgotPassForm.controls;
  }
  get mobNumberFormValidation() {
    return this.mobileLoginForm.controls;
  }

  get f() {
    //return this.pricerangeform.controls;
    return this.addCashForm.controls;
  }
  onSubmit(): void {
    this.loginFormSubmitted = true;
    //stop here if form is invalid
    if (this.loginForm.invalid) {
      return;
    }
    const username = this.loginForm.value.email;
    const password = this.loginForm.value.password;
    this.userType = "player";
    this.authService.login(username, password, this.userType, false).subscribe(
      (data) => {
        this.userData = data;
        this.tokenStorage.saveToken(this.userData.data.access_token);
        this.tokenStorage.saveUser(this.userData.data);
        this.tokenStorage.getAuthStatus(this.userData.data);
        this.isLoginFailed = false;
        this.isLoggedIn = true;
        this.roles = this.tokenStorage.getUser().roles;
        this.getRoleDetails();
        this.getRoleList();
        this.getUserList(this.lazyLoadEvent, this.mode);
        this.loginRegisterModal = false;
        let currentUrl = "/find-partner";
        this.router.routeReuseStrategy.shouldReuseRoute = () => false;
        this.router.onSameUrlNavigation = "reload";
        this.router.navigate([currentUrl]);
        //this.onClickJoin(this.contest);
      },
      (error) => {
        //throw Error();
        this.loginFormSubmitted = false;
        this.errorMessage =
          "Login failed: Please check your login credentials...! ";
        let currentUrl = "/sign-in";
        this.router.routeReuseStrategy.shouldReuseRoute = () => false;
        this.router.onSameUrlNavigation = "reload";
        this.router.navigate([currentUrl]);
        this.isLoginFailed = true;
      }
    );
    //});
  }
  getRoleDetails() {
    const querystring = "filterByroleId=" + this.userData.data.userdata.role;
    this.roleService.searchRoleDetails(querystring).subscribe(
      (data) => {
        this.userRoleId = data.data.items[0]["id"];
        this.permissions = data.data.items[0]["permissions"];
        this.tokenStorage.saveUserPermissions(this.permissions);
        this.roleList = data.data.items[0];
      },
      (err) => {
        this.errorMessage = err.error.message;
      }
    );
  }
  getRoleList() {
    var querystring = "filterByDisable=false&filterByStatus=true";
    var rolearray = [];
    this.roleService.getRoleList(querystring).subscribe(
      (data) => {
        var roleList = data.data.items;
        roleList.forEach((element) => {
          rolearray.push({
            roleid: element.id,
            rolename: element.user_role_name,
          });

        });
        if (rolearray.length > 0) {
          this.tokenStorage.saveRolelist(rolearray);
        }
      },
      (err) => {
        this.errorMessage = err.error.message;
      }
    );
  }
  getRoles() {
    this.partid = this.partnerid;
    let query = "filterByDisable=false&filterByStatus=true";
    this.roleService.getRoleListWithoutAuth(query).subscribe(
      (data) => {
        // this.partnerform.get('playerValue').setValue({name : this.item['user_role_name'],code : this.item[this.partid]})
        if (data.data.items) {
          let rolesArray = data.data.items;
          this.roleFilteredArr.forEach((role) => {
            let rIndex = this.findSelectedIndexByRole(role, rolesArray);
            if (rIndex != -1) {
              rolesArray.splice(rIndex, 1);
            }
          });
          if (this.partnerid == undefined) {
            rolesArray.forEach((rElement) => {
              if (rElement.user_role_name == "player") {
                this.selectedCategories = rElement.id;
                this.partnerid = this.selectedCategories;
                this.slug = rElement.user_role_name;
                //                this.getBanner();
                this.mode = "category";
                this.getUserList(this.selectedCategories, this.mode);
              }
            });
          }
          this.userCategories = rolesArray;
        }
        this.userCategories.forEach((element) => {
          if (element.id === this.partnerid) {
            this.partnerform.controls.playerValue.setValue(element);
            this.selectedCategories = element.id;
            this.slug = element.user_role_name;
            // this.getBanner();
            this.mode = "category";
            this.getUserList(this.lazyLoadEvent, this.mode);
          }
        });
      },
      (err) => {
        this.errorMessage = err.error.message;
      }
    );
  }
  getBanner() {
    let query =
      "?filterByDisable=false&filterByStatus=true&filterBySlug=" + this.slug;
    this.bannerService.getbannerList(query).subscribe(
      (data) => {
        this.loading = false;
        this.bannerList = data.data.items;
        this.totalRecords = data.data.totalCount;
        this.bannerList.forEach((element) => {
          this.webBannerImageList = element.banner_image;
          this.mobileBannerImageList = element.mobile_banner_image;
        });
      },
      (err) => {
        this.errorMessage = err.error.message;
      }
    );
  }
  partnerid: any;
  getplayerid() {
    this.subscribeService._partnerid.subscribe((res) => {
      if (res) {
        this.partnerid = res;
        this.selectedCategories = res;
        this.mode = "category";
        this.getRoles();
        //this.getUserList(this.selectedCategories, this.mode);
      } else {
        this.getRoles();
      }
    });
  }

  findSelectedIndexByRole(role, arrayName) {
    let index = -1;
    for (let i = 0; i < arrayName.length; i++) {
      if (arrayName[i].user_role_name === role) {
        index = i;
        break;
      }
    }
    return index;
  }

  onOtpChange(otp) {
    this.otp = otp;
  }
  onClickOtpSubmit() {
    if (this.otp == undefined || this.otp.length < 6) {
      this.showOtpErrors = true;
      return;
    }
    let otpData = {
      otp: this.otp,
      mobileNumber: this.mobileNumber,
    };
    this.authService.verifyOtp(otpData).subscribe(
      (data) => {
        // setTimeout(() => {
        this.showMessage = true;
        // this.signUpForm.reset();
        this.submitted = false;
        this.showOtpForm = false;
        this.showOtpErrors = false;
        this.activeIndex = Number(0);
        //this.message = 'User Added';
        setTimeout(() => {
          this.showMessage = false;
        }, 5000);
      },
      (err) => {
        this.showOtpErrorsMsg = true;
        this.otpErrorMessage = err.error.error;
        setTimeout(() => {
          this.showOtpErrorsMsg = false;
        }, 5000);
      }
    );
  }
  onClickForgotPassword() {
    this.showForgotPasswordForm = true;
  }
  onForgotPassSubmit() {
    this.submitted = true;
    if (this.forgotPassForm.valid) {
      this.authService.requestPassword(this.forgotPassForm.value).subscribe(
        (res) => {
          if (res["errors"]) {
            this.errorMessage = res["errors"];
            this.successMessage = "";
          } else {
            this.successMessage = res;
            this.errorMessage = "";
          }
          this.showMessage = true;
          setTimeout(() => {
            this.submitted = false;
            this.forgotPassForm.reset();
            this.showMessage = false;
            this.successMessage = "";
          }, 2000);
        },
        (err) => {
          this.successMessage = "";
          this.showMessage = true;
          this.errorMessage = err.error.data.errors;
        }
      );
    }
  }
  onMobilePhoneSubmit(mode) {
    let mobileData;
    if (mode != "resend") {
      this.submitted = true;
      //stop here if form is invalid
      if (this.mobileLoginForm.invalid) {
        return;
      }
      mobileData = this.mobileLoginForm.value.mobileNumber;
      this.mobileNumber = mobileData;
    } else {
      mobileData = this.mobileNumber;
    }
    this.authService.generateMobileOtp(mobileData).subscribe(
      (res) => {
        this.showMobileLoginOtpForm = true;
        this.showResendButton = false;
        this.timer(1);
      },
      (err) => {
        this.showMobileFormErrors = true;
        this.mobileFormsErrors = err.error.error;
        setTimeout(() => {
          this.showMobileFormErrors = false;
        }, 2000);
        this.showMobileLoginOtpForm = false;
      }
    );
  }
  resendOtp() {
    let mode = "resend";
    this.onMobilePhoneSubmit(mode);
  }
  onClickOtpLoginSubmit() {
    if (this.otp == undefined || this.otp.length < 6) {
      this.showOtpErrors = true;
      return;
    }
    let otpData = {
      otp: this.otp,
      mobileNumber: this.mobileNumber,
    };
    this.authService.otpLogin(otpData).subscribe(
      (data) => {
        this.userData = data;
        this.tokenStorage.saveToken(this.userData.data.access_token);
        this.tokenStorage.saveUser(this.userData.data);
        this.tokenStorage.getAuthStatus(this.userData.data);
        this.isLoggedIn = true;
        this.roles = this.tokenStorage.getUser().roles;
        this.getRoleDetails();
        this.getRoleList();
        // let currentUrl = '/';
        // this.router.routeReuseStrategy.shouldReuseRoute = () => false;
        // this.router.onSameUrlNavigation = 'reload';
        // this.router.navigate([currentUrl]);
      },
      (err) => {
        this.showOtpLoginErrors = true;
        this.otpLoginErrors = err.error.error;
        setTimeout(() => {
          this.showOtpLoginErrors = false;
        }, 2000);
      }
    );
  }
  timer(minute) {
    // let minute = 1;
    let seconds: number = minute * 60;
    let textSec: any = "0";
    let statSec: number = 60;
    const prefix = minute < 10 ? "0" : "";
    const timer = setInterval(() => {
      seconds--;
      if (statSec != 0) statSec--;
      else statSec = 59;
      if (statSec < 10) {
        textSec = "0" + statSec;
      } else textSec = statSec;
      this.displayTime = `${prefix}${Math.floor(seconds / 60)}:${textSec}`;
      if (seconds == 0) {
        clearInterval(timer);
        this.showResendButton = true;
      }
    }, 1000);
  }
  onForgotPassBack() {
    this.showForgotPasswordForm = false;
  }
  onClickUserCategory(event) {
    this.selectedCategories = [];
    if (event.value != null) {
      let category = event.value;
      this.selectedCategories = category.id;
      this.slug = category.user_role_name;
      //this.getBanner();
    }
    this.mode = "category";
    this.getUserList(this.lazyLoadEvent, this.mode);
  }
  getState() {
    let query =
      "filterByDisable=false&orderBy=name&sortBy=1&filterByCountryCode=IN";
    this.stateService.getstateList(query).subscribe((res) => {
      // this.states = res.data.items;
      res.data.items.forEach((element) => {
        let stateObj = {
          name: element.name,
          id: element.id,
        };
        this.stateListData.push(stateObj);
      });
      this.states = JSON.parse(JSON.stringify(this.stateListData));
    });
  }

  onSearchState(event) {
    this.states = this.stateListData.filter(ele => ele.name.toLowerCase().includes(event.target.value.toLowerCase()));
  }

  getCity(code) {
    this.citiesListData = [];
    let query =
      "?filterByStatus=true&filterByDisable=false&orderBy=name&sortBy=1&filterByStateId=" +
      code;
    this.cityService.getcityList(query).subscribe((res) => {
      this.totalCityRecords = res.data.totalCount;
      this.citiesListData = res.data.items;
      this.cities = JSON.parse(JSON.stringify(this.citiesListData));
    });
  }
  
  onSearchCity(event) {
    this.cities = this.citiesListData.filter(ele => ele.name.toLowerCase().includes(event.target.value.toLowerCase()));
  }

  onClickState(event) {
    if (event.checked.length > 0) {
      this.stateCode = [...event.checked.map(ele => ele.id)];
      let state = event.value;
      // this.getCity(this.stateCode);
      this.selectedStates = [...event.checked.map(ele => ele.name)];
    } else {
      this.stateCode = [];
      this.selectedStates = [];
      this.cities = [];
      // this.getCity(null);
    }
    this.mode = "state";
    this.getUserList(this.lazyLoadEvent, this.mode);
  }
  onClickCity(event) {
    if (event.checked.length != null) {
      let city = [...event.checked.map(ele => ele.name)];
      this.selectedCities = city;
    } else {
      this.selectedCities = [];
    }
    this.mode = "city";
    this.getUserList(this.lazyLoadEvent, this.mode);
  }

  onClickpricerange() {
    this.minvalue = this.pricerangeform.value["minvalue"];
    this.maxvalue = this.pricerangeform.value["maxvalue"];
    this.mode = "pricerange";
    this.getUserList(this.lazyLoadEvent, this.mode);
  }
  onClickRating() {
    this.minrating = this.ratingrangeform.value["minvalue"];
    this.maxrating = this.ratingrangeform.value["maxvalue"];
    this.mode = "ratingrange";
    this.getUserList(this.lazyLoadEvent, this.mode);
  }
  onRecurringSelect(recurring, event) {
    if (event.checked) {
      this.recurringArray.forEach((element) => {
        if (element.id == recurring.id) {
          let index = this.findIndexById(element.id, this.recurringArray);
          if (index != -1) {
            this.recurringArray[index].status = true;
            this.selectedRecurring.push(element.slug);
          }
        }
      });
    } else {
      this.recurringArray.forEach((element) => {
        if (element.id == recurring.id) {
          let index = this.findIndexById(element.id, this.recurringArray);
          let recurringIndex = this.findIndexByName(
            element.slug,
            this.selectedRecurring
          );
          if (index != -1) {
            this.recurringArray[index].status = false;
          }
          if (recurringIndex != -1) {
            this.selectedRecurring.splice(recurringIndex, 1);
          }
        }
      });
    }
    this.mode = "recurring";
    this.getUserList(this.lazyLoadEvent, this.mode);
  }
  onClickTodayRecurringSelect(day, event) {
    if (event.checked) {
      this.isToday = true;
    } else {
      this.isToday = false;
    }
    this.mode = "recurring";
    this.getUserList(this.lazyLoadEvent, this.mode);
  }
  onTomorrowRecurringSelect(day, event) {
    if (event.checked) {
      this.isTomorrow = true;
    } else {
      this.isTomorrow = false;
    }
    this.mode = "recurring";
    this.getUserList(this.lazyLoadEvent, this.mode);
  }
  onSelectStartDate(event) {
    this.selectedStartDate = moment(event).format("YYYY-MM-DD");
    this.mode = "date";
    this.getUserList(this.lazyLoadEvent, this.mode);
  }

  onSelectEndDate(event) {
    this.selectedEndDate = moment(event).format("YYYY-MM-DD");
    this.mode = "date";
    this.getUserList(this.lazyLoadEvent, this.mode);
  }
  onAmenitiesSelect(amenities, event) {
    if (event.checked.length > 0) {
      this.selectedFilteredAmenities = [...event.checked.map(ele => ele.slug)];
    } else {
      this.selectedFilteredAmenities = [];
    }
    this.mode = "amenities";
    this.getUserList(this.lazyLoadEvent, this.mode);
  }
  findIndexByName(name, arrayName) {
    let index = -1;
    for (let i = 0; i < arrayName.length; i++) {
      if (arrayName[i] === name) {
        index = i;
        break;
      }
    }
    return index;
  }
  findIndexById(id, arrayName) {
    let index = -1;
    for (let i = 0; i < arrayName.length; i++) {
      if (arrayName[i].id === id) {
        index = i;
        break;
      }
    }
    return index;
  }
  findSelectedIndexById(id, arrayName) {
    let index = -1;
    for (let i = 0; i < arrayName.length; i++) {
      if (arrayName[i] === id) {
        index = i;
        break;
      }
    }
    return index;
  }
  findIndexByUserScheduleId(id, arrayName) {
    let index = -1;
    for (let i = 0; i < arrayName.length; i++) {
      if (arrayName[i].userScheduleId === id) {
        index = i;
        break;
      }
    }
    return index;
  }
  getUserList(event: LazyLoadEvent, mode) {
    this.lazyLoadEvent = event;
    this.isLoadingPartners = true;
    // var query = "?filterByDisable=false&filterByBookingStatus=Pending&filterByApprovedVideo=true";
    var query = "?filterByDisable=false&filterByStatus=true&filterByBookingStatus=Pending&activeusers=true&excludeUser=true&filterByUserId=" + this.userId;

    var pagenumber = 1;
    var params = "";
    var rows = 10;
    if (event !== undefined) {
      if (event.first != undefined && event.first == 0) {
        pagenumber = event.first + 1;
      } else if (event.first != undefined && event.first > 0) {
        pagenumber = event.first / event.rows + 1;
      } else {
        pagenumber = 1;
      }
      if (event.rows != undefined) {
        rows = event.rows;
      } else {
        rows = 10;
      }
      if (event.sortField != undefined && event.sortOrder != undefined) {
        var orderBy = "";
        if (event.sortOrder == 1) {
          orderBy = "DESC";
        } else {
          orderBy = "ASC";
        }
        query += "&sortBy=" + event.sortField + "&orderBy=" + orderBy;
      }
    }
    if (event instanceof Object) {
      this.router.navigate([], {
        relativeTo: this.route,
        queryParams: { page: pagenumber, limit: rows },
        queryParamsHandling: 'merge',
        replaceUrl: true
      });
    }
    query += "&filterByrollId=" + this.selectedCategories;
    if (mode == "category") {
      // query += "&filterByrollId=" + this.selectedCategories;
      // if (this.minvalue != null && this.maxvalue != null) {
      //   query += "&filterByMinPrice=" + this.minvalue + "&filterByMaxPrice=" + this.maxvalue;
      // }
      // if (this.selectedStates.length > 0) {
      //   query += "&filterByScheduleStateName=" + this.selectedStates;
      // }
      // if (this.selectedCities.length > 0) {
      //   query += "&filterByScheduleCityName=" + this.selectedCities;
      // }
      // if (this.selectedFilteredAmenities.length > 0) {
      //   query += "&filterByScheduleAmenitiesSlug=" + this.selectedFilteredAmenities;
      // }
      // if (this.selectedRecurring.length > 0) {
      //   query += "&filterByScheduleDateRecurring=" + this.selectedRecurring;
      // }
      // if (this.selectedFilteredDate.length > 0) {
      //   query += "&filterByDate=" + this.selectedFilteredDate;
      // }
    }
    if (mode == "ratingrange") {
      query +=
        "&filterByMinRating=" +
        this.minrating +
        "&filterByMaxRating=" +
        this.maxrating;
      if (this.minvalue != null && this.maxvalue != null) {
        query += "&filterByMinPrice=" + this.minvalue + "&filterByMaxPrice=" + this.maxvalue;
      }
      // if (this.selectedStates.length > 0) {
      //   query += "&filterByScheduleStateName=" + this.selectedStates;
      // }
      // if (this.selectedCities.length > 0) {
      //   query += "&filterByScheduleCityName=" + this.selectedCities;
      // }
      // if (this.selectedFilteredAmenities.length > 0) {
      //   query += "&filterByScheduleAmenitiesSlug=" + this.selectedFilteredAmenities;
      // }
      // if (this.selectedRecurring.length > 0) {
      //   query += "&filterByScheduleDateRecurring=" + this.selectedRecurring;
      // }
      // if (this.selectedFilteredDate.length > 0) {
      //   query += "&filterByDate=" + this.selectedFilteredDate;
      // }
    }
    if (mode == "state" && this.selectedStates.length !== 0) {
      // query += "&filterByScheduleStateName=" + this.selectedStates;
      query += "&filterByStateNames=" + this.selectedStates;
      // if (this.minvalue != null && this.maxvalue != null) {
      //   query +=
      //     "&filterByMinPrice=" +
      //     this.minvalue +
      //     "&filterByMaxPrice=" +
      //     this.maxvalue;
      // }
      //
      // if (this.selectedCategories.length > 0) {
      //   query += "&filterByrollId=" + this.selectedCategories;
      // }
      // if (this.selectedCities.length > 0) {
      //   query += "&filterByScheduleCityName=" + this.selectedCities;
      // }
      // if (this.selectedFilteredAmenities.length > 0) {
      //   query += "&filterByScheduleAmenitiesSlug=" + this.selectedFilteredAmenities;
      // }
      // if (this.selectedRecurring.length > 0) {
      //   query += "&filterByScheduleDateRecurring=" + this.selectedRecurring;
      // }
      // if (this.selectedFilteredDate.length > 0) {
      //   query += "&filterByDate=" + this.selectedFilteredDate;
      // }
    }
    if (mode == "city") {
      query += "&filterByCityNames=" + this.selectedCities;
      // if (this.minvalue != null && this.maxvalue != null) {
      //   query +=
      //     "&filterByMinPrice=" +
      //     this.minvalue +
      //     "&filterByMaxPrice=" +
      //     this.maxvalue;
      // }
      // if (this.selectedCategories.length > 0) {
      //   query += "&filterByrollId=" + this.selectedCategories;
      // }
      if (this.selectedStates.length > 0) {
        // query += "&filterByScheduleStateName=" + this.selectedStates;
        query += "&filterByStateNames=" + this.selectedStates;
      }
      // if (this.selectedFilteredAmenities.length > 0) {
      //   query += "&filterByScheduleAmenitiesSlug=" + this.selectedFilteredAmenities;
      // }
      // if (this.selectedRecurring.length > 0) {
      //   query += "&filterByScheduleDateRecurring=" + this.selectedRecurring;
      // }
      // if (this.selectedFilteredDate.length > 0) {
      //   query += "&filterByDate=" + this.selectedFilteredDate;
      // }
    }
    if (mode == "amenities") {
      query +=
        "&filterByScheduleAmenitiesSlug=" + this.selectedFilteredAmenities;
      // if (this.minvalue != null && this.maxvalue != null) {
      //   query += "&filterByMinPrice=" + this.minvalue + "&filterByMaxPrice=" + this.maxvalue;
      // }
      // if (this.selectedCategories.length > 0) {
      //   query += "&filterByrollId=" + this.selectedCategories;
      // }
      // if (this.selectedStates.length > 0) {
      //   query += "&filterByScheduleStateName=" + this.selectedStates;
      // }
      // if (this.selectedCities.length > 0) {
      //   query += "&filterByScheduleCityName=" + this.selectedCities;
      // }
      // if (this.selectedRecurring.length > 0) {
      //   query += "&filterByScheduleDateRecurring=" + this.selectedRecurring;
      // }
      // if (this.selectedFilteredDate.length > 0) {
      //   query += "&filterByDate=" + this.selectedFilteredDate;
      // }
    }
    if (mode == "recurring") {
      //query += "&filterByScheduleDateRecurring=" + this.selectedRecurring;
      if (this.selectedFilteredDate.length > 0) {
        query += "&filterByStartDate=" + moment(this.selectedFilteredDate).startOf('day').utc().format('YYYY-MM-DDTHH:mm');
      }

      if (this.isToday === true) {
        let date = moment().local();
        //query += "&filterByToday=" + moment(date).local().format("YYYY-MM-DDTHH:mm");
        query += "&filterByToday=" + date.startOf('day').utc().format("YYYY-MM-DDTHH:mm");
      }
      if (this.isTomorrow === true) {
        let tDate = moment().local();
        //query += "&filterByTomorrow=" + moment(date).add(1, "d").local().format('YYYY-MM-DDTHH:mm');
        query += "&filterByTomorrow=" + tDate.startOf('day').add(1, "d").utc().format("YYYY-MM-DDTHH:mm");
      }
      // if (this.minvalue != null && this.maxvalue != null) {
      //   query += "&filterByMinPrice=" + this.minvalue + "&filterByMaxPrice=" + this.maxvalue;
      // }
      // // if (this.selectedCategories.length > 0) {
      // //   query += "&filterByrollId=" + this.selectedCategories;
      // // }
      // if (this.selectedStates.length > 0) {
      //   query += "&filterByScheduleStateName=" + this.selectedStates;
      // }
      // if (this.selectedCities.length > 0) {
      //   query += "&filterByScheduleCityName=" + this.selectedCities;
      // }
      // if (this.selectedFilteredAmenities.length > 0) {
      //   query += "&filterByScheduleAmenitiesSlug=" + this.selectedFilteredAmenities;
      // }
      // if (this.selectedFilteredDate.length > 0) {
      //   query += "&filterByDate=" + this.selectedFilteredDate;
      // }
    }

    if (mode == "pricerange") {
      query +=
        "&filterByMinPrice=" +
        this.minvalue +
        "&filterByMaxPrice=" +
        this.maxvalue;
      if (this.minrating != null && this.maxrating != null) {
        query += "&filterByMinRating=" + this.minrating + "&filterByMaxRating=" + this.maxrating;
      }
      // if (this.selectedCategories.length > 0) {
      //   query += "&filterByrollId=" + this.selectedCategories;
      // }
      // if (this.selectedStates.length > 0) {
      //   query += "&filterByScheduleStateName=" + this.selectedStates;
      // }
      // if (this.selectedCities.length > 0) {
      //   query += "&filterByScheduleCityName=" + this.selectedCities;
      // }
      // if (this.selectedFilteredAmenities.length > 0) {
      //   query += "&filterByScheduleAmenitiesSlug=" + this.selectedFilteredAmenities;
      // }
      // if (this.selectedFilteredDate.length > 0) {
      //   query += "&filterByDate=" + this.selectedFilteredDate;
      // }
    }

    if (mode == "date") {
      // query += "&filterByDate=" + moment(this.selectedFilteredDate).local().format('YYYY-MM-DDTHH:mm');
      query += "&filterByFStartDate=" + moment(this.selectedStartDate).local().format('YYYY-MM-DDTHH:mm');
      query += "&filterByFEndDate=" + moment(this.selectedEndDate).local().format('YYYY-MM-DDTHH:mm');
      // if (this.minvalue != null && this.maxvalue != null) {
      //   query += "&filterByMinPrice=" + this.minvalue + "&filterByMaxPrice=" + this.maxvalue;
      // }
      // if (this.selectedCategories.length > 0) {
      //   query += "&filterByrollId=" + this.selectedCategories;
      // }
      // if (this.selectedStates.length > 0) {
      //   query += "&filterByScheduleStateName=" + this.selectedStates;
      // }
      // if (this.selectedCities.length > 0) {
      //   query += "&filterByScheduleCityName=" + this.selectedCities;
      // }
      // if (this.selectedFilteredAmenities.length > 0) {
      //   query += "&filterByScheduleAmenitiesSlug=" + this.selectedFilteredAmenities;
      // }
    }

    if (this.playerName !== '' && this.playerName !== null) {
      query += "&filterByName=" + this.playerName;
    }
    // at the time of download hide pagination option
    if (this.downloadFlg == false) {
      if (params != undefined && params != "") {
        query += "&pageSize=" + rows + "&pageNumber=" + pagenumber + params;
      } else {
        query += "&pageSize=" + rows + "&pageNumber=" + pagenumber;
      }
    } else {
      if (params != undefined && params != "") {
        query += params;
      }
    }
    if (this.route.snapshot.params.userId) {
      let query1 = "?filterByDisable=false&filterByBookingStatus=Pending&filterByUserId=" + this.route.snapshot.params.userId;
      this.userService.getUserListWithoutAuth(query1).subscribe(
        (data) => {
          window.scroll(0, 0);
          this.findPartnerList = data.data;
          if (this.findPartnerList.length > 0) {
            this.roleId = this.findPartnerList[0].role;
            var query =
              "?filterByDisable=false&filterByBookingStatus=Pending&filterByrollId=" +
              this.findPartnerList[0].role;
            this.userCategories.forEach((element) => {
              if (element.id === this.findPartnerList[0].role) {
                this.partnerform.controls.playerValue.setValue(element);
                this.selectedCategories = element.id;
                this.slug = element.user_role_name;
              }
            });
            this.userService.getUserListWithoutAuth(query).subscribe(
              (restData) => {
                let dataConcat = restData.data.filter(
                  (user) => user.id !== this.route.snapshot.params.userId
                );
                // this.filteredList = this.findPartnerList.filter(
                //   (user) => user.id !== loginUserId
                // );
                this.filteredList = this.findPartnerList.concat(dataConcat);
                // Filter out items from findPartnerList where id matches loginUserId
                const loginUserId = this.userId;

                this.totalUserRecords = this.filteredList.length;
                this.isLoadingPartners = false;
                if (data.data.length > 0) {
                  if (this.filteredList.length > 0) {

                    this.filteredList.forEach((el) => {
                      if (el.amenities != undefined) {
                        if (el.amenities.length > 0) {
                          this.amenitiesData = [];
                          el.amenities.forEach((aElement) => {
                            this.defaultAmenitiesArray.forEach((element) => {
                              if (element.slug == aElement.slug) {
                                this.amenitiesData.push(element.name);

                              }
                            });
                          });
                        }
                        el["amenitiesData"] = this.amenitiesData.join(', ');
                      }
                      if (el['rolename'] == "Pro Player" || el["rolename"] == "Coach") {
                        el["showDescription"] = true;
                        el["rating"] = el["proplayerRating"];
                        el["showPlayerLink"] = false;
                      } else if (el["rolename"] == "Player") {
                        el["showDescription"] = false;
                        el["rating"] = el["rating"];
                        el["showPlayerLink"] = true;
                      }
                      el["startDate"] =
                        new Date(el["startDate"])
                      el["endDate"] =
                        new Date(el["endDate"])
                    });
                  }
                }
                this.isLoadingPartners = false;
              },
              (err) => {
                this.errorMessage = err.error.message;
                this.isLoadingPartners = false;
              }
            );
          } else {
             this.isLoadingPartners = false;
          }
        },
        (err) => {
          this.errorMessage = err.error.message;
          this.isLoadingPartners = false;
        }
      );
    } else {
      const loginUserId = this.userId;
      this.userService.getUserListWithoutAuth(query).subscribe(
        (data) => {
          this.findPartnerList = data.data;
          // console.log(this.findPartnerList)
          // Filter out items from findPartnerList where id matches loginUserId
          this.filteredList = this.findPartnerList



          // .filter(
          //   (user) => user
          // );
          if (data.totalCount === 0) {
            this.nodata = true;
          } else {
            this.nodata = false;
          }

          this.totalUserRecords = data.totalCount;
          this.isLoadingPartners = false;

          //console.log("TotalUserRecords --", this.totalUserRecords);

          if (data.data.length > 0) {
            if (this.filteredList.length > 0) {
              this.filteredList.forEach((el) => {
                if (el.amenities != undefined) {
                  if (el.amenities.length > 0) {

                    let amenitiesData = [];
                    el.amenities.forEach((aElement) => {
                      this.defaultAmenitiesArray.forEach((element) => {
                        if (element.slug == aElement.slug) {
                          amenitiesData.push(element.name);
                        }
                      });
                    });
                    el["amenitiesData"] = amenitiesData.join(', ');

                    if (el['rolename'] == "Pro Player" || el["rolename"] == "Coach") {
                      el["showDescription"] = true;
                      el["rating"] = el["proplayerRating"];
                      el["showPlayerLink"] = false;
                    } else if (el["rolename"] == "Player") {
                      el["showDescription"] = false;
                      el["rating"] = el["rating"];
                      el["showPlayerLink"] = true;
                    }

                    // if (el['rolename'] == "Pro Player") {
                    //   el["showDescription"] = true;
                    //   el["description"];
                    // } else if (el["rolename"] == "Coach" || el["rolename"] == "Player") {                      
                    //   el["showDescription"] = false;
                    // } 

                  }
                }
              });
            }
          }

        },
        (err) => {
          this.errorMessage = err.error.message;
        }
      );
    }
  }

  userRequests() {
    var query = "?filterByUserId=" + this.userId + "&exceptPendingStatus=Pending&filterByOpponent=true";

    this.scheduleservice.getScheduleList(query).subscribe(
      (res) => {
        this.userRequestsCount = res.data.totalCount;
      },(err) => {
        this.errorMessage = err.error.message;
      });
  }

  searchlink() {
    this.router.navigate(["/"]);
  }
  chatlink() {
    this.router.navigate(["/"]);
  }
  onClickMyScheduled() {
    if (Object.keys(this.loggedInUser).length === 0) {
      this.router.navigate(['/']);
      return;
    }
    if (this.isLoggedIn == false) {
      this.loginRegisterModal = true;
      return;
    }
    // console.log(this.isProfileComplete);
    // console.log(this.isplayerVideoApproved);
    // console.log(this.playervideoClip);

    //if (this.loggedInUser.userdata.isProfileComplete === false || this.isplayerVideoApproved === false) {
    // if (this.isProfileComplete === false || (this.isplayerVideoApproved === false)){// && this.playervideoClip!="")) {
    //   this.router.navigate(["/profile-edit"]);
    //   return;
    // } else {
    //   this.router.navigate(["/my-schedule"]);
    // }
    if (this.isProfileComplete === false) {// && this.playervideoClip!="")) {
      // this.router.navigate(["/profile-edit"]);
      this.welcomeLogin = true;
      return;
    } else if (this.kycAdded == false && this.userAge > 17) {
      this.router.navigate(["/kyc"]);
    } else {
      let currentDate = moment(new Date()).toISOString();
      this.scheduleService.viewScheduleStartDate(currentDate);
      this.router.navigate(["/my-schedule"]);
    }
  }

  hideWelcomeLoginDialog() {
    this.welcomeLogin = false;
  }

  async onClickShowScheduleDialog(findPartner) {
    if (this.isLoggedIn === false) {
      this.loginRegisterModal = true;
      return;
    }


    // this.roleName = this.loggedInUser.userdata.rolename;
    if (this.roleName == "Pro Player" || this.roleName == "Coach") {
      this.showDescription = true;
    } else if (this.roleName == "Player") {
      this.showDescription = false;
    }





    //if (this.loggedInUser.userdata.isProfileComplete === false || this.isplayerVideoApproved === false) {
    // if (this.isProfileComplete === false || this.isplayerVideoApproved === false){ // && this.playervideoClip!="")) {
    //   this.router.navigate(["/profile-edit"]);
    //   return;
    // }
    if (Object.keys(this.loggedInUser).length === 0) {
      this.router.navigate(['/']);
      return;
    }

    if (this.isProfileComplete === false) {// && this.playervideoClip!="")) {
      // this.router.navigate(["/profile-edit"]);
      this.welcomeLogin = true;
      return;
    }
    if (this.kycAdded == false && this.userAge > 17) {
      this.router.navigate(["/kyc"]);
      return;
    }
    let date = new Date();

    this.fapSelectedDate = new Date(findPartner.startDate);

    this.selectedDate = moment(this.fapSelectedDate).format("YYYY-MM-DD");
    this.opponentId = findPartner.id;
    await this.loadViewCalendar();
    await this.getScheduleList(this.lazyLoadEvent);
    this.showScheduleMatchDialog = true;
  }

  // Component class
  totalEntryFee(): number {
    // Assuming you have an array of selected schedules named 'selectedSchedules'
    return this.selectedScheduleData.reduce(
      (total, schedule) => total + parseFloat(schedule.charges),
      0
    );
  }

  // totalEntryFee(): number {
  //   return this.selectedSchedule.reduce((total, fee) => total + parseFloat(fee.charges), 0);
  // }

  onScheduleMatchDialogClose() {
    this.selectedScheduleData = this.selectedSchedule;
    this.selectedScheduleId = null;
    this.scheduleForm.reset();
    this.selectedSchedule = [];
    this.termsAndConditionsCheck = false;
    // let currentUrl = this.router.url;
    // this.router.navigateByUrl("/", { skipLocationChange: true }).then(() => {
    //   this.router.navigate([currentUrl]);
    // });

  }
  onScheduleCheckboxSelect(event, sid, sname, Time, charge, scheduleDate) {
    let obj = {
      userScheduleId: sid,
      charges: charge,
      startTime: Time,
      scheduleDate: scheduleDate,
      userName: sname,
      opponentUserId: this.userId,
      bookingStatus: "Booked",
      // termsAndConditions: "true",
    };

    this.totalFee = this.totalEntryFee();

    if (event.checked) {
      // this.scheduleList.forEach(element => {
      //   if (element.slug == sid) {
      //     element.status = true;
      //   }
      // });
      this.selectedSchedule.push(obj);
    } else {
      // this.scheduleList.forEach(element => {
      //   if (element.id ==sid ) {
      //     element.status = false;
      //   }
      // });
      let index = this.findIndexByUserScheduleId(sid, this.selectedSchedule);
      if (index != -1) {
        this.selectedSchedule.splice(index, 1);
      }
    }
  }

  onScheduleSubmitRegister() {
    //this.Walletdialog = false;
    this.thankYouMsg = false;
    this.Walletdialog = true;
    if (this.selectedSchedule.length > 0) {
      this.showScheduleError = false;
    } else {
      this.showScheduleError = true;
    }
    if (this.walletBalance >= this.totalEntryFee()) {
      this.onRadioClick();
      this.thanYoumodal = true;
      //return;
    } else {
      this.displayCashMs = true;
      this.totalleftCash = this.walletBalance - this.totalEntryFee();
      return;

    }

    const scheduleData = {
      schedule: this.selectedScheduleData,
    };

    scheduleData["schedule"] = this.selectedScheduleData;
    scheduleData["termsAndConditions"] = this.isTermsAndConditionsAccepted;
    scheduleData["paymentId"] = this.paymentId

    this.scheduleService.updateUserSchedule(this.userId, scheduleData).subscribe(
      (data) => {
        this.showScheduleMatchDialog = false;
        //
        this.selectedScheduleData = [];

        this.thanYoumodal = true;
        this.Walletdialog = false;
        this.countdownInProgress = true;
        this.changeDetectRef.detectChanges();
        const interval = setInterval(() => {
          this.countdown--;
          if (this.countdown === 0) {
            clearInterval(interval);
            this.countdownInProgress = false;
            //window.location.reload();
            // let currentUrl = this.router.url;
            let currentUrl = '/find-partner';
            this.router.routeReuseStrategy.shouldReuseRoute = () => false;
            this.router.onSameUrlNavigation = "reload";
            this.router.navigate([currentUrl], { queryParams: { page: 1, limit: 10 } });
          }
          this.changeDetectRef.detectChanges();
        }, 1000);
        // this.changeDetectRef.detectChanges();
        //this.messageService.add({ key: 'toastmsg', severity: 'success', summary: 'Successful', detail: 'Match schedule request sent.', life: 3000 });
      },

      (error) => {
        this.messageService.add({
          key: "toastmsg",
          severity: 'error',
          summary: error.error.error,
          detail: "",
          life: 6000,
        });
      }
    );
  }

  onScheduleSubmit() {

    if (this.termsAndConditionsCheck == false) {
      this.showTermsAndConditionError = true;
      return;
    }
    this.termsAndConditions = false;


    if (this.selectedSchedule.length > 0) {
      this.showScheduleError = false;
    } else {
      this.showScheduleError = true;
      return;
    }
    let scheduleData = {
      schedule: this.selectedSchedule,
    };
    this.showScheduleMatchDialog = false;

    // scheduleData['schedule'] = this.selectedSchedule;
    // this.scheduleService.updateUserSchedule(this.userId, scheduleData).subscribe(
    //   data => {
    //     this.showScheduleMatchDialog = false;
    //     this.selectedSchedule = [];
    //     //this.messageService.add({ key: 'toastmsg', severity: 'success', summary: 'Successful', detail: 'Match schedule request sent.', life: 3000 });
    //   },
    //   error => {
    //   }
    // );
  }
  async loadViewCalendar() {
    //let startYearDate = moment().startOf('year').format('YYYY-MM-DD');
    let sDate = new Date();
    let endDate = moment(sDate).add(2, "year").format("YYYY-MM-DD");
    let edate = new Date(endDate);
    let time = edate.getTime() - sDate.getTime();
    let days = time / (1000 * 3600 * 24); //Diference in Days
    this.options = {};
    this.eventService.getEvents().then((events) => {
      events = [];
      this.events = events;
      let query =
        "?filterByDisable=false&filterByStatus=true&filterByBookingStatus=Pending&filterByUserId=" +
        this.opponentId + "&sortBy=startDate&orderBy=ASC";
      this.scheduleService.getScheduleList(query).subscribe(
        (response) => {
          this.scheduleListArr = response.data.items;
          // console.log("ScheduleListArr:-", this.scheduleListArr);
          if (this.scheduleListArr.length > 0) {
            this.scheduleListArr.forEach((element) => {
              let startDate = moment(element["startDate"]).utc();
              let slotStartHours = moment(element["startDate"]).hours();
              let slotStartMinutes = moment(element["startDate"]).minutes();
              let slotEndHours = moment(element["endDate"]).hours();
              let slotEndMinutes = moment(element["endDate"]).minutes();
              let scheduleDataObj = {
                id: element.id,
                startDate: element.startDate,
                endDate: element.endDate,
                slotStartHours: slotStartHours,
                slotStartMinutes: slotEndMinutes,
                slotEndHours: slotEndHours,
                slotEndMinutes: slotEndMinutes,
              };
              this.scheduleListArray.push(scheduleDataObj);
            });
          }
          this.scheduleListArray.forEach((schedule) => {
            for (let i = 0; i <= days; i++) {
              let date = moment(sDate).add(i, "days").format("YYYY-MM-DD"); //To set date in calendar date format should be 'YYYY-MM-DD'
              let newStartDate = new Date(sDate);
              newStartDate.setHours(schedule.slotStartHours);
              newStartDate.setMinutes(schedule.slotEndMinutes);
              //let newSDate = moment(newStartDate).add(i, 'days').format('YYYY-MM-DD HH:mm');

              let newEndDate = new Date(sDate);
              newEndDate.setHours(schedule.slotEndHours);
              newEndDate.setMinutes(schedule.slotEndMinutes);
              let newSDate = moment(newStartDate)
                .add(i, "days").local()
                .format("YYYY-MM-DD");
              let newEDate = moment(newEndDate).add(i, "days").local().format("YYYY-MM-DD");
              if (date === moment(schedule.startDate).format("YYYY-MM-DD")) {
                //let slotTime = moment(schedule.slotdate).local().format("h:mm a") + " - " + moment(schedule.sessionenddate).local().format("h:mm a");                
                if (date === moment(this.fapSelectedDate).format("YYYY-MM-DD")) {
                  this.events.push({
                    id: schedule.id,
                    // title: moment(schedule.startDate).format('h:mm a'),
                    // classNames: "view",
                    start: newSDate,
                    end: newEDate,
                    color: "#20b033",
                    textColor: '#378006',
                    display: 'background'
                  });
                } else {
                  this.events.push({
                    id: schedule.id,
                    // title: moment(schedule.startDate).format('h:mm a'),
                    // classNames: "view",
                    start: newSDate,
                    end: newEDate,
                    // color: "#08b394",
                    // textColor: '#378006',
                    // display:'background'

                  });
                }
                //date = moment(startYearDate).add(i, 'days').format('YYYY-MM-DD');
              }
            }
          });
          this.scheduleListArray = [];
          this.options = {
            ...this.options,
            ...{ events: events },
            eventContent: function (info) { },
          };
        },
        (error) => { }
      );
    });
    const startOfMonth = moment().startOf("month").format("YYYY-MM-DD");
    this.options = {
      //initialDate: moment(sDate).format('YYYY-MM-DD'),
      // headerToolbar: {
      //   left: 'prev,next today',
      //   center: 'title',
      //   right: 'dayGridMonth,timeGridWeek,timeGridDay'
      // },
      contentHeight: "360px",
      eventOrder: 'displayOrder',
      editable: false,
      selectable: true,
      dateClick: (info) => {
        // let date =info.date
        // this.selectedDate=moment(date).utc().format("YYYY-MM-DD")
        // console.log( this.selectedDate)
        this.selectedDate = info.dateStr;
        this.getScheduleList(this.lazyLoadEvent);
      },
      validRange: {
        start: this.selectedDate,
      },

      selectMirror: true,
      allDaySlot: true,
      showNonCurrentDates: true,
      initialView: "dayGridMonth",
    };
  }
  async getScheduleList(event: LazyLoadEvent) {
    this.lazyLoadEvent = event;
    let pagenumber = 1;
    let params = "";
    let rows = 1;
    let query = "?filterByDisable=false&filterByStatus=true&filterByBookingStatus=Pending&filterByStartDate=" + moment(this.selectedDate).startOf('day').utc().format('YYYY-MM-DDTHH:mm');

    if (this.isLoggedIn == true) {
      query += "&filterByUserId=" + this.opponentId;
      //query += "&filterByUserIdCheck=true";
    }
    this.scheduleService.getScheduleList(query).subscribe(
      (response) => {
        this.scheduleList = response.data.items;
        //this.selectedSchedule = [];
        if (this.scheduleList.length > 0) {
          this.scheduleList.forEach((element) => {
            let startDate = moment(element["startDate"]).utc();
            let endDate = moment(element["endDate"]).utc();
            this.scheduleForm.addControl(element.id, new FormControl());
            element["startDate"] = moment(startDate).local().format("h:mm a z");
            element["sheduleDate"] = moment(startDate).local().format();
            element["endDate"] = moment(endDate).local().format("h:mm a z");
            element["status"] = false;

            if (element.amenities.length > 0) {
              // element['amenities'];
              this.ament = [];
              element.amenities.forEach((aElement) => {
                this.amenitiesArray.forEach((element) => {
                  if (element.slug == aElement.slug) {
                    this.ament.push(element.name);
                    let obj = {
                      slug: element.slug,
                      status: true,
                    };
                    this.selectedAmenities.push(obj);
                  }
                });
              });
            }
            element["ament"] = this.ament;
          });
        }

        this.scheduleList.sort((a, b) => {
          return moment(a.startDate, 'h:mm a').diff(moment(b.startDate, 'h:mm a'));
        });
        this.totalRecords = response.data.totalCount;
      },
      (error) => { }
    );
  }

  onCashSubmit(event: Event) {
    this.Walletdialog = true;
    event.preventDefault();
    this.added_amount = this.addCashForm.value.amount;
    this.submitted = true;
    if (this.addCashForm.invalid) {
      return;
    }
    var addCashData = this.addCashForm.value;
    addCashData["userId"] = this.loggedInUser.userdata.id;
    if (addCashData["amount"] > 0) {
      this.Addcashmodal = false;
      addCashData = JSON.stringify(addCashData, null, 4);
      const amt = addCashData["amount"];
      this.walletpaymentService
        .addWalletPayment(addCashData)
        .subscribe((data) => {
          let options: any = {
            key: environment.RAZORPAY_KEY_ID,
            amount: this.addCashForm.value.amount * 100, // amount should be in paise format to display Rs 1255 without decimal point
            currency: "INR",
            name: "TPL", // company name or product name
            description: "User Added Cash to wallet", // product description
            image: "../../../../assets/images/logo.png", // company logo or product image
            order_id: data.data["orderId"], // user_id created by you in backend
            modal: {
              // We should prevent closing of the form when esc key is pressed.
              escape: false,
            },
            notes: {
              // include notes if any
            },
            theme: {
              color: "#0c238a",
            },
          };
          options.handler = (response, error) => {
            options.response = response;
            this.paymentId = response.razorpay_payment_id;
            let verifyPaymentData = {
              razorpay_payment_id: response.razorpay_payment_id,
              razorpay_order_id: response.razorpay_order_id,
              razorpay_signature: response.razorpay_signature,
              userId: this.loggedInUser.userdata.id,
              walletType: "CASH",
              amount: this.addCashForm.value.amount,
            };
            // call your backend api to verify payment signature & capture transaction
            //commented below code as verify will be done by webhook
            // this.walletpaymentService
            //   .verifyWalletpayment(verifyPaymentData)
            //   .subscribe((paymentdata) => {
            //     // this.walletBalance += this.added_amount;
            //     // this.totalleftCash = this.walletBalance - this.totalEntryFee();
            //     this.getUserBalance();
            //     // this.Addcashmodal = false;
            //     // this.Walletdialog = true;
            //   });
            this.getUserBalance();
            this.thankYouMsg = true;
            setTimeout(() => {
              this.hideDiv();
            }, 1000); // Hide the div after 1000 milliseconds (1 seconds)
            setTimeout(() => {
              this.onScheduleSubmitRegister();
            }, 2000);
          };
          options.modal.ondismiss = () => {
            // handle the case when user closes the form while transaction is in progress
          };
          const rzp = new this.winRef.nativeWindow.Razorpay(options);
          rzp.open();

          return;
        });
    }
  }
  getUserBalance() {
    if (this.isLoggedIn) {
      var query =
        "?filterByDisable=false&filterByUserid=" + this.loggedInUser.userdata.id;
      this.userWalletService.getUserWalletList(query).subscribe(
        (data) => {
          this.walletBalance = data.data.totalCash - data.data.totalDeductedCash;
          this.totalCash = data.data.totalCash;
          this.totalCoins = data.data.totalCoins;
          if (this.walletBalance > this.totalEntryFee()) {
            this.onRadioClick();
            this.isRegisterButtonEnabled();
          } else {
          }
          if (this.thankYouMsg === true) {
            this.totalleftCash = this.walletBalance - this.totalEntryFee();
          }
          //this.cdr.detectChanges();
          this.changeDetectRef.detectChanges();
        },
        (err) => {
          this.errorMessage = err.error.message;
        }
      );
    }
  }
  cashclose() {
    this.submitted = false;
  }
  closeThankyou() {
    this.showThankyouModal = false;
    let currentUrl = this.router.url;
    this.router.navigateByUrl("/", { skipLocationChange: true }).then(() => {
      this.router.navigate([currentUrl]);
    });
  }
  thankyouModal() {
    const tournamentPlayerData = {
      category: this.myForm.value.fields,
      userId: this.loggedInUser.userdata.id,
      tournamentId: this.tournamentid,
      // termsAndConditions: this.termsAndConditions,
      // paymentOption: selectedPaymentOption // Add the selected payment option here
    };
  }
  calculateTotalEntryFee() {
    this.selectedEntryFee = this.selectedEntryFees.reduce(
      (total, fee) => total + fee,
      0
    );
  }
  walletDailogClose() {
    let currentUrl = "/find-partner";
    // this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    // this.router.onSameUrlNavigation = "reload";
    // this.router.navigate([currentUrl]);
  }
  clear() {
    this.selectedState = [];
    this.selectedCity = [];
    this.selectedAmenities = [];
    this.selectedStartDate = null;
    this.selectedEndDate = null;
    this.pricerangeform.reset();
    this.ratingrangeform.reset();
    this.mode = "category";
    this.getUserList(this.lazyLoadEvent, this.mode);
    const obj = {
      target: {
        value: ''
      }
    }
    // this.getCity(null);
    this.onSearchState(obj);
    this.searchedStateName = null;
    this.onSearchCity(obj);
    this.searchedCityName = null;
  }

  playVideo(videoName) {
    this.selectedVideo = "";
    this.changeDetectRef.detectChanges();
    this.selectedVideo = videoName;

    this.showVideo = true;
  }

  onshowVideoClose() {
    this.selectedVideo = "";
    this.showVideo = false;
  }
  onClickViewSchedule(findPartner) {
    // this.fapSelectedDate = new Date(findPartner.startDate);
    this.scheduleService.viewScheduleStartDate(findPartner.startDate)
    // this.subscribeService.pendingReqData(date);
    this.router.navigate(['/my-schedule']);
  }
  hideDiv() {
    this.thankYouMsg = false;
  }
  loadUserKyc() {

    var query1 = "?filterDisable=false&filterByPrimary=true&filterByuserId=" + this.userId;
    this.userService.getUserKycDetailsList(query1).subscribe((data) => {
      this.allKycList = data.items;
      if (this.allKycList.length > 0) {

        if (this.allKycList[0]?.isDocumentComplete) {
          this.kycAdded = true
        }
      } else {
        this.kycAdded = false;
      }


    });
  }

  onTermsAndConditionsSelect(event) {
    this.termsAndConditionsCheck = (event.checked) ? true : false;
    this.isTermsAndConditionsAccepted = this.scheduleForm.value.termsAndConditions;
  }

  onShow() {
    this.showMore = !this.showMore;
  }

  toggleDescription(scheduleId: string) {
    if (this.selectedScheduleId === scheduleId) {
      this.selectedScheduleId = null; // Deselect if already selected
    } else {
      this.selectedScheduleId = scheduleId; // Otherwise, select the clicked schedule
    }
  }

  isSelectedSchedule(scheduleId: string): boolean {
    return this.selectedScheduleId === scheduleId;
  }
onDownloadClick(position: 'left' | 'right' | 'top' | 'bottom' | 'center' | 'topleft' | 'topright' | 'bottomleft' | 'bottomright'){
  this.position = position;
  this.downloadModal = true; 
}
    showMobileFilter() {
      this.mobilFilter = true;
    }

  // ===== trackBy functions for *ngFor optimization =====
  trackByPartner(index: number, item: any): string {
    return item?.id || index;
  }

  trackByState(index: number, item: any): string {
    return item?.id || index;
  }

  trackByCity(index: number, item: any): string {
    return item?.id || index;
  }

  trackByAmenity(index: number, item: any): string {
    return item?.id || index;
  }

  trackByBanner(index: number, item: any): string {
    return item?.id || index;
  }
}
